import { render } from "./FeeAnalytics.vue?vue&type=template&id=8b182aea&scoped=true"
import script from "./FeeAnalytics.vue?vue&type=script&lang=js"
export * from "./FeeAnalytics.vue?vue&type=script&lang=js"

import "./FeeAnalytics.vue?vue&type=style&index=0&id=8b182aea&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b182aea"],['__file',"resources/js/components/FeeAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b182aea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b182aea', __exports__)) {
    api.reload('8b182aea', __exports__)
  }
  
  module.hot.accept("./FeeAnalytics.vue?vue&type=template&id=8b182aea&scoped=true", () => {
    api.rerender('8b182aea', render)
  })

}


export default __exports__